import { useState, useEffect } from 'react';
import {ClockIcon} from '../Icons/icons'

export function HeurePicker({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const [selectedH, setSelectedH] = useState(null);
  const [selectedM, setSelectedM] = useState(null);

  const handleHour = (h) => {
    setSelectedH(h);
    if (selectedM !== null) {
      const v = `${String(h).padStart(2,'0')}h${String(selectedM).padStart(2,'0')}`;
      onChange(v);
      setOpen(false);
    }
  };

  const handleMin = (m) => {
    setSelectedM(m);
    if (selectedH !== null) {
      const v = `${String(selectedH).padStart(2,'0')}h${String(m).padStart(2,'0')}`;
      onChange(v);
      setOpen(false);
    }
  };

  return (
    <div>
      <div className="vv-heure-display" onClick={() => setOpen(!open)}>
        {value
          ? <span className="vv-heure-val">{value}</span>
          : <span className="vv-heure-val empty">Choisir l'heure</span>
        }
        <ClockIcon />
      </div>

      {open && (
        <div className="vv-heure-picker">
          <span className="vv-heure-picker-label">Heure</span>
          <div className="vv-heure-grid">
            {Array.from({ length: 24 }, (_, h) => (
              <div
                key={h}
                className={`vv-heure-cell${selectedH === h ? ' selected' : ''}`}
                onClick={() => handleHour(h)}
              >
                {String(h).padStart(2,'0')}h
              </div>
            ))}
          </div>
          <span className="vv-heure-picker-label">Minutes</span>
          <div className="vv-heure-grid mins">
            {[0, 15, 30, 45].map(m => (
              <div
                key={m}
                className={`vv-heure-cell${selectedM === m ? ' selected' : ''}`}
                onClick={() => handleMin(m)}
              >
                {String(m).padStart(2,'0')}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default HeurePicker;
